export const imageGroup1 = [
    "/gallery/pic_num_1.jpg",
    "/gallery/pic_num_2.jpg",
    "/gallery/pic_num_3.jpg",
    "/gallery/pic_num_4.jpg",
    "/gallery/pic_num_5.jpg",
    "/gallery/pic_num_6.jpg",
    "/gallery/pic_num_7.jpg",
    "/gallery/pic_num_8.jpg",
    "/gallery/pic_num_9.jpg",
    "/gallery/pic_num_10.jpg"
];


export const imageGroup2 = [
    "/gallery/pic_num_11.jpg",
    "/gallery/pic_num_12.jpg",
    "/gallery/pic_num_13.jpg",
    "/gallery/pic_num_14.jpg",
    "/gallery/pic_num_15.jpg",
    "/gallery/pic_num_16.jpg",
    "/gallery/pic_num_17.jpg"
];